<template>
  <div>
    <div v-for="(v, index) in vols" :key="index">
      <item-book
        :book="v"
        type="book"
        :active="activeBook"
        :checked="getBooksChecked[v.id]"
        @set-volumes="setVols"
        :volumesCount="book.volumes_length"
      />
    </div>
  </div>
</template>
<script>
import { treeBooks } from "@/store/modules/books.js";
import itemBook from "./itemBook.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vols: [],
    };
  },
  components: {
    itemBook,
  },
  computed: {
    ...mapGetters("bookList", ["getBooksChecked"]),
  },
  props: ["count", "main-volume", "book", "activeBook"],
  methods: {
    setVols(mainVolume, value, volumes) {
      this.$emit("set-volumes", mainVolume, value, volumes);
    },
  },
  mounted() {
    for (let i = 0; i < this.book.volumes_length; i++)
      if (this.book[`volumes_${i}_id`] != this.book.id) {
        let book = treeBooks.get(treeBooks.root, this.book[`volumes_${i}_id`]);
        this.vols.push(book);
      }
  },
};
</script>
